import React from 'react'
import type { WithStyles } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/core'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import WarningIcon from '@material-ui/icons/Warning'

const styles = createStyles({
  root: {},
  icon: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
})

export interface ResetAdornmentProps extends WithStyles<typeof styles> {
  onResetClick?: (e: React.MouseEvent) => void
  onClearClick?: (e: React.MouseEvent) => void
  resetLabel?: string
  clearLabel?: string
}

function ResetAdornment({ onResetClick, onClearClick, classes, ...props }: ResetAdornmentProps) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const resetLabel = props?.resetLabel ?? 'Reset Value'
  const clearLabel = props?.clearLabel ?? 'Clear Value'

  function handleClick(event) {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  function resetValue(event: React.MouseEvent) {
    event.stopPropagation()
    setAnchorEl(null)
    onResetClick(event)
  }

  function clearValue(event: React.MouseEvent) {
    event.stopPropagation()
    setAnchorEl(null)
    onClearClick(event)
  }

  return (
    <>
      <WarningIcon onClick={handleClick} classes={{ root: classes.icon }} />
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {onResetClick && <MenuItem onClick={resetValue}>{resetLabel}</MenuItem>}
        {onClearClick && <MenuItem onClick={clearValue}>{clearLabel}</MenuItem>}
      </Menu>
    </>
  )
}

export default withStyles(styles)(ResetAdornment)
